import { ComponentProps } from 'react';
import clsx from 'clsx';

import icons from './Icons.svg';
import { IconName } from './types';

import styles from './Icon.module.css';

interface Props extends Omit<ComponentProps<'svg'>, 'name'> {
  name: IconName | { icon: IconName };
}

const IconsUrl = (icons as unknown as { src: string }).src || icons;

export default function Icon({ name, className, 'aria-label': label, ...props }: Props) {
  const icon = name && typeof name === 'object' && 'icon' in name ? name.icon : name;

  return (
    <svg
      className={clsx(styles.icon, className)}
      aria-hidden={!label}
      aria-label={label}
      {...props}
    >
      <use xlinkHref={`${IconsUrl}#${icon}`}></use>
    </svg>
  );
}
